module.exports = __webpack_public_path__ + "static/media/product-summary-2.f97fce9c.jpg";